var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"data align-self-start",on:{"click":function($event){return _vm.stopInterval()}}},[_vm._t("button")],2)}
var staticRenderFns = []

export { render, staticRenderFns }